import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, OutlinedInput, Typography, useMediaQuery } from '@mui/material';
import Modal from '@mui/material/Modal';
import { useFormik } from 'formik';
import React from 'react';
import { sxDarkGreyBody, sxFormError, sxLabel } from '../../assets/styles/CommonSxProps';
import { EmailCelularValidation } from '../../interfaces/validation/EmailCelularValidation';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { getBenef } from '../../Store/storages/BeneficiarioStorage';
import DefaultButton from '../Accessibility/DefaultButton';
import WhiteContainer from '../Accessibility/WhiteContainer';
import { sxInputNumberModal } from '../ModalNewPhone/sxProps';
import './styles.css';
import { sxButton, sxButtonContained, sxInputEmailModal, sxTypographyTitle } from './sxProps';
import { cellphoneMask } from '../../utils/PhoneRegex';


const ModalConfirmData: React.FC<{
  showModal: boolean,
  handleShowModal: () => void,
  handleConfirmData: (email: string, celular: string) => void
}> = ({ showModal, handleShowModal, handleConfirmData }) => {

  const { textStyleAccessibility } = useAccessibility();

  const benef = getBenef();

  const mobileScreen = useMediaQuery('(max-width: 899px)');

  const formik = useFormik({
    initialValues: {
      email: benef?.email || '',
      cel: benef?.cel || '',
    },
    validationSchema: EmailCelularValidation,
    onSubmit: (values) => {
      handleConfirmData(values.email, values.cel);
      formik.resetForm();
    },
    validateOnChange: false
  });

  const closeModal = () => {
    handleShowModal();
    formik.resetForm();
  }

  const containedButton = (
    <DefaultButton
      type='submit'
      sx={sxButtonContained}
      text='Continuar'
      variant={'contained'}
    />
  );

  const outlinedButton = (
    <DefaultButton
      onClick={closeModal}
      sx={sxButton}
      variant='outlined'
    >
      <Typography style={{ color: '#00995D' }}>Cancelar</Typography>
    </DefaultButton>
  );


  return (
    <div>
      {showModal && <Modal
        open={showModal}
        onClose={closeModal}
      >
        <form onSubmit={formik.handleSubmit}>
          <WhiteContainer className='container-modal-confirm-email'>
            <div className='modal-confirm-email-header'>
              <Typography component="h1" style={textStyleAccessibility} sx={sxTypographyTitle}>Confirme seu e-mail e número de celular</Typography>
              <IconButton
                aria-label="fechar"
                onClick={closeModal}
              >
                <FontAwesomeIcon icon={faTimes} size="1x" color='black' />
              </IconButton>
            </div>
            <Typography style={textStyleAccessibility} sx={sxDarkGreyBody}>
              É necessário confirmar o e-mail e o número de celular para prosseguir.
              Você pode atualizá-los agora ou continuar com os dados atuais.
            </Typography>
            <Box display={'flex'} flexDirection={'column'} width={'100%'}>
              <Typography style={textStyleAccessibility} sx={sxLabel}>E-mail</Typography>
              <label htmlFor='email' aria-label='email' />
              <OutlinedInput
                placeholder='email@email.com'
                id='email'
                type={'email'}
                value={formik.values.email}
                onChange={(e) => { formik.setFieldValue('email', e.target.value); }}
                name='email'
                style={textStyleAccessibility}
                error={!!formik.errors.email}
                maxRows={1}
                inputProps={{ maxLength: 100 }}
                sx={sxInputEmailModal}
              />
              <Typography style={textStyleAccessibility} sx={sxFormError}>{formik.errors.email}</Typography>
            </Box>
            <Box display={'flex'} flexDirection={'column'} width={'100%'} >
              <Typography style={textStyleAccessibility} sx={sxLabel}>Celular</Typography>
              <label htmlFor='cel' aria-label='celular' />
              <OutlinedInput
                placeholder='(11) 99999-9999'
                id='cel'
                type={'text'}
                value={formik.values.cel}
                onChange={(e) => { formik.setFieldValue('cel', cellphoneMask(e.target.value)); }}
                name='cel'
                style={textStyleAccessibility}
                error={!!formik.errors.cel}
                maxRows={1}
                inputProps={{ maxLength: 15 }}
                sx={sxInputNumberModal}
              />
              <Typography style={textStyleAccessibility} sx={sxFormError}>{formik.errors.cel}</Typography>
            </Box>
            <div className='email-modal-buttons-holder'>
              {mobileScreen ? containedButton : outlinedButton}
              {mobileScreen ? outlinedButton : containedButton}
            </div>
          </WhiteContainer>
        </form>
      </Modal>}
    </div>
  );
};

export default ModalConfirmData;
